import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Info, X } from '@phosphor-icons/react';

interface HelpModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
}

export const HelpModal = ({
  open,
  onClose,
  title,
  description,
}: HelpModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Info size={20} />
        <Box component='span' sx={{ flexGrow: 1 }}>
          {title}
        </Box>
        <IconButton size='small' onClick={onClose}>
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            whiteSpace: 'pre-wrap',
            fontSize: '0.875rem',
            color: '#475467',
          }}
        >
          {description}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
